import type { Domain } from '@/config/domain/type';

export const trademarksOnlineUnitedKingdom: Domain = {
    domain: import.meta.env.VITE_TMO_UK_DOMAIN,
    website: 'https://www.trademarksonline.co.uk',
    shortCode: 'tmo-uk',
    markSource: 'TMOV2-UK',
    name: 'Trademarks Online United Kingdom',
    title: 'Apply for your UK trademark',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your UK trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-UK.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/faq' },
        { label: 'About', url: '/contact' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '/img/TMO-Banner-UK-XL.png',
    gtmId: 'GTM-WJRDB52T',
};
